import React from "react";
import { SocialIcon } from "react-social-icons";
import "./project.styles.css";

const Project = ({
  header,
  title,
  bgUrl,
  description,
  link,
  btnText,
  videoUrl,
}) => {
  const hasImage = bgUrl && bgUrl.length > 0;

  const isVideo =
    hasImage &&
    (bgUrl.endsWith(".mp4") ||
      bgUrl.endsWith(".webm") ||
      bgUrl.endsWith(".ogv"));

  return (
    <div className="project-card">
      {isVideo ? (
        <video
          autoPlay
          loop
          muted
          playsInline
          className="project-media"
        >
          <source src={bgUrl} type="video/mp4" />
        </video>
      ) : hasImage ? (
        <div
          className="project-media project-image"
          style={{ backgroundImage: `url(${bgUrl})` }}
        />
      ) : (
        <div className="project-media project-placeholder" />
      )}

      <div className="project-content">

        <div className="project-top">
          <p className="project-header">{header}</p>

          <SocialIcon
            url={link}
            bgColor="#ffffff"
            className="project-github"
            target="_blank"
          />
        </div>

        <h2 className="project-title">
          {title}
        </h2>

        <div className="project-description">
          {description?.map((item, index) => (
            <p key={index}>{item}</p>
          ))}
        </div>

        <div className="project-actions">
          {videoUrl && (
            <a
              href={videoUrl}
              target="_blank"
              rel="noreferrer"
              className="project-button project-button-secondary"
            >
              Demo
            </a>
          )}

          <a
            href={link}
            target="_blank"
            rel="noreferrer"
            className="project-button project-button-primary"
          >
            {btnText}
          </a>
        </div>

      </div>
    </div>
  );
};

export default Project;